// Import Swiper React components
import { FaStar, FaRegCalendar, FaPhoneAlt, FaHeart, FaMapMarkerAlt, FaShareAlt } from "react-icons/fa";
import { FiAlertCircle } from "react-icons/fi";

// Import Swiper styless
import 'swiper/css';

import '../App.css';

import Carousel from 'react-bootstrap/Carousel';
import { Link } from 'react-router-dom';

/* 컴포넌트 */
import Header from '../components/Header';
import Footer from '../components/Footer';

const DetailPage = () => {
  return (
    <>
      {/* 헤더 */}
      <Header />
      <Carousel variant="dark" id='Detail_Swiper'>
        <Carousel.Item className='detail_box'>
            <img src='https://kimsikyoung.github.io/images/HaiRound/search/search2/인스타헤어/2.png' alt='슬라이드1'/>
        </Carousel.Item>
        <Carousel.Item className='detail_box'>
            <img src='https://kimsikyoung.github.io/images/HaiRound/search/search2/인스타헤어/3.png' alt='슬라이드2'/>
        </Carousel.Item>
        <Carousel.Item className='detail_box'>
            <img src='https://kimsikyoung.github.io/images/HaiRound/search/search2/인스타헤어/4.png' alt='슬라이드3'/>
        </Carousel.Item>
        <Carousel.Item className='detail_box'>
            <img src='https://kimsikyoung.github.io/images/HaiRound/search/search2/인스타헤어/1.png' alt='슬라이드4'/>
        </Carousel.Item>
      </Carousel>

      <div className='Detail_Wrap'>
        <div className='Detail_nav'>
          <span>홈</span>
          <p>메뉴</p>
          <p>디자이너</p>
          <p>스타일</p>
          <p>리뷰 2,025</p>
        </div>
        <div className='Detail_title'>
          <p className='Detail_top'>
            인스타헤어
          </p>
          <p className='Detail_star'>
            <FaStar fill='orange' /><FaStar fill='orange' /><FaStar fill='orange' /><FaStar fill='orange' /><FaStar fill='orange' />&nbsp; 4.9 (2,025)
          </p>
        </div>
        <div className='Detail_notice'>
          <div className='notice_title'> NOTICE </div>
          <p className='notice_text1'>
            헤어스타일 만족도 압도적 1위 (기장추가없음)
          </p>
          <p className='notice_text2'>
            저희 인스타헤어는 기장추가에 대한 불안···
            <p className='notice_text3'>더보기</p>
          </p>
        </div>
        <div className='Detail_text'>
          <p className='Detail_text1'><FaRegCalendar /> 영업시간
            <p>10:30 ~ 20:30</p>
          </p>
          <p className='Detail_text2'><FiAlertCircle /> 매장정보
            <p>최고의 디자이너 / 친절한 서비스 머리잘하는곳으로
              <p>고객님들에게 헤어스타일뿐 아니라···
                <p className='Detail_text3'>더보기
                </p>
              </p>
            </p>
          </p>
        </div>

        <div className="Detail_icon">
          <div className="D_icon">
            <FaHeart fill="red" />
            <span>1,174</span>
          </div>
          <div className="D_icon">
            <FaMapMarkerAlt />
            <span>위치</span>
          </div>
          <div className="D_icon">
            <FaPhoneAlt />
            <span>전화</span>
          </div>
          <div className="D_icon">
            <FaShareAlt />
            <span>공유</span>
          </div>
        </div>

      </div>
      {/* 푸터 */}
      <Footer />
    </>
  )
};

export default DetailPage;